import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import IndexPage from './Components/Pages/IndexPage';
import ClientsPage from './Components/Pages/ClientsPage';
import ApiScopesPage from './Components/Pages/ApiScopesPage';
import { ToastContainer } from "react-toastify";

export default function App(props) {
  return (
    <div style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/backgroundImage.jpg)`,  backgroundRepeat: "no-repeat", position: "absolute", width: "100%", height: "100%", zIndex: "0"}}>
        <Router basename={`${process.env.PUBLIC_URL}`}>
          <Switch>
            <Route exact path="/">
                <Redirect to="/index" />
            </Route>
            <Route path="/index" component={() => <IndexPage {...props} />} />
            <Route path="/client" component={() => <ClientsPage {...props} />} />
            <Route path="/api" component={() => <ApiScopesPage {...props} />} />
          </Switch>
        </Router>
        <ToastContainer />
    </div>
  );
}